import { render } from "./sectionone.vue?vue&type=template&id=1822167e&scoped=true"
import script from "./sectionone.vue?vue&type=script&lang=js"
export * from "./sectionone.vue?vue&type=script&lang=js"

import "./sectionone.vue?vue&type=style&index=0&id=1822167e&scoped=true&lang=css"

import exportComponent from "/home/kira/project/web/SPACDYNA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1822167e"]])

export default __exports__